import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    __lastPixelEvent?: {
      event: string;
      path: string;
      timestamp: number;
      source: 'hook' | 'manual';
    };
    __pixelHistory?: Array<NonNullable<Window['__lastPixelEvent']>>;
  }
}

export default function useMetaPixel() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const payload = {
      event: 'PageView',
      path: location.pathname,
      timestamp: Date.now(),
      source: 'hook' as const,
    };

    window.__lastPixelEvent = payload;
    if (!Array.isArray(window.__pixelHistory)) {
      window.__pixelHistory = [];
    }
    window.__pixelHistory.push(payload);

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);
}

